import { SearchOutlined } from "@ant-design/icons";
import {
  Button,
  Col,
  Dropdown,
  Form,
  Input,
  Menu,
  Modal,
  PageHeader,
  Row,
  Select,
  Space,
  Spin,
  Statistic,
  Table,
  Tag
} from "antd";
import { Component } from "react";
import { CSVLink } from "react-csv";
import Highlighter from "react-highlight-words";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { DELETE, GET, POST, UPDATE } from "../constants/request-type";
import {
  delete_order,
  get_all_order,
  get_all_user,
  order,
  user
} from "../constants/routes";
import { service_api } from "../constants/url";
import { MakeRequestAsync } from "../functions/axios";
import { decryptSingleData } from "../functions/cryptojs";
import { openNotificationWithIcon } from "../functions/notification";

import { reverseDateFormat, todayDate } from "../functions/dateFunctions";

import Order_details from "../forms/order_details";

import logger from "../../utils/logger.js";
const token = sessionStorage.getItem("auth_token");

const { Option } = Select;

class Order extends Component {
  state = {
    selectedRowKeys: [],
    searchText: "",
    searchedColumn: "",
    load: true,
    data: [],
    list: [],
    chef: [],
    chef_selected: "all",
    selected_date: todayDate(),
    start: null,
    end: null,
    selected: true,
    overall: true,
    allowed: false,
    blocked: false,
    driver_around: [],
    openModal: false,
    ride_selected: null,
    show: "all",
    rate: null,
    rate_view: false,
    isModalOpen: false,
    orderList: [],
    looking_done: false
  };

  componentDidMount() {
    this.getData();
  }

  static defaultProps = {
    center: {
      lat: 43.65107,
      lng: -79.347015
    },
    zoom: 5
  };

  showModal = () => {
    this.setState({ isModalOpen: true });
  };

  handleOk = () => {
    this.setState({ isModalOpen: false });
  };

  handleCancel = () => {
    this.setState({ isModalOpen: false });
  };

  getData = async () => {
    const request_details = {
      type: GET,
      url: service_api,
      route: order + "/" + get_all_order,
      data: null,
      token: token
    };

    const request_details_chef = {
      type: GET,
      url: service_api,
      route: user + "/" + get_all_user,
      data: null,
      token: token
    };

    try {
      const [response, response_chef] = await Promise.all([
        MakeRequestAsync(request_details),
        MakeRequestAsync(request_details_chef)
      ]);

      this.setState({
        load: false,
        chef: decryptSingleData(response_chef?.data?.user),
        data: decryptSingleData(response.data.order)
      });
    } catch (err) {
      this.setState({ load: false });
      return openNotificationWithIcon(
        "error",
        `${err?.response?.data?.message}`
      );
    }
  };

  handleStatus = async (id, status) => {
    const data = {
      status: status
    };
    const request_details = {
      type: UPDATE,
      url: service_api,
      route: order + "/" + "update-order-admin" + "/" + id,
      data: data,
      token: token
    };

    try {
      await MakeRequestAsync(request_details);
      return setTimeout(() => window.location.reload(), 1000);
    } catch (err) {
      return openNotificationWithIcon("error", `${err.response.data}`);
    }
  };

  onSelectChange = (selectedRowKeys) => {
    logger.log("selectedRowKeys changed: ", selectedRowKeys);
    this.setState({ selectedRowKeys });
  };

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => this.handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              this.setState({
                searchText: selectedKeys[0],
                searchedColumn: dataIndex
              });
            }}
          >
            Filter
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select(), 100);
      }
    },
    render: (text) =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      )
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex
    });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };

  handleDelete = async (id) => {
    const request_details = {
      type: DELETE,
      url: service_api,
      route: order + "/" + delete_order + "/" + id,
      token: token
    };
    try {
      await MakeRequestAsync(request_details);
      return setTimeout(() => window.location.reload(), 1000);
    } catch (err) {
      return openNotificationWithIcon(
        "error",
        `${err?.response?.data?.message}`
      );
    }
  };

  startBroadcast = async () => {
    const { orderList } = this.state;

    if (orderList.length === 0) {
      return openNotificationWithIcon(
        "error",
        "Aucune commande n'a été selectionnée"
      );
    }

    this.setState({
      load: true
    });

    for (var i = 0; i < orderList.length; i++) {
      const request_details = {
        type: POST,
        url: service_api,
        route: order + "/" + "broadcast-order" + "/" + orderList[i],
        data: {},
        token: token
      };
      try {
        await MakeRequestAsync(request_details);
      } catch (err) {
        return openNotificationWithIcon(
          "error",
          `${err?.response?.data?.message}`
        );
      }
    }

    this.setState({
      load: false,
      looking_done: true
    });

    return openNotificationWithIcon(
      "success",
      "Les recherches sont en cours et dure en moyenne 3 minutes"
    );
  };

  render() {
    const columns = [
      {
        title: "Id",
        dataIndex: "_id",

        ...this.getColumnSearchProps("_id")
      },

      {
        title: "Facturation",
        dataIndex: "billing_details",
        render: (text) => (
          <Tag color={"purple"}>
            <span>
              Montant total: <b>{"$" + text?.amount?.toFixed(2)}</b>
            </span>
            <br />
            <span>
              Gain chef: <b>{"$" + text?.earned_chef?.toFixed(2)}</b>
            </span>
            <br />
            <span>
              Gain Pani Chef: <b>{"$" + text?.earned_pani?.toFixed(2)}</b>
            </span>
            <br />
            <span>
              Gain Livraison: <b>{"$" + text?.delivery_price?.toFixed(2)}</b>
            </span>
            <br />
            <span>
              Gain Livreur: <b>{"$" + text?.earn_deliverman?.toFixed(2)}</b>
            </span>
            <br />
            <span>
              Gain Pani Livraison:{" "}
              <b>{"$" + text?.earn_delivery_pani?.toFixed(2)}</b>
            </span>
            <br />
            <span>
              Taxes: <b>{"$" + text?.tax?.toFixed(2)}</b>
            </span>
            <br />
            <span>
              Tips: <b>{"$" + text?.tip?.toFixed(2)}</b>
            </span>
            <br />
            <span>
              Date de livraison: <b>{text?.delivery_date}</b>
            </span>
          </Tag>
        )
      },
      {
        title: "Payé",
        dataIndex: "paid",
        render: (text) => (
          <Tag color={text === true ? "green" : "volcano"}>
            {text === true ? "Oui" : "Non"}
          </Tag>
        )
      },
      {
        title: "Livreur",
        dataIndex: "deliverman_id",
        render: (text) =>
          text === null ? (
            "Aucun Livreur"
          ) : (
            <Tag color={"purple"}>
              <img
                src={text?.pic}
                style={{
                  width: 60,
                  height: 60,
                  objectFit: "contain"
                }}
                alt={"deliverman-logo"}
              />
              <br />
              <span>{text?.firstname + " " + text?.lastname}</span>
              <br />
              <span>{text?.email}</span>
              <br />
              <span>{text?.number}</span>
            </Tag>
          )
      },
      {
        title: "Utilisateur",
        dataIndex: "user_id",
        render: (text) => (
          <Tag color={"purple"}>
            <span>{text?.firstname + " " + text?.lastname}</span>
            <br />
            <span>{text?.email}</span>
            <br />
            <span>{text?.number}</span>
          </Tag>
        )
      },
      {
        title: "Chef",
        dataIndex: "chef_id",
        render: (text) => (
          <Tag color={"purple"}>
            <span>{text?.firstname + " " + text?.lastname}</span>
            <br />
            <span>{text?.email}</span>
            <br />
            <span>{text?.number}</span>
          </Tag>
        )
      },
      {
        title: "Status",
        dataIndex: "status",
        render: (text) => (
          <Tag
            color={
              text === 0
                ? "orange"
                : text === 1
                  ? "green"
                  : text === 2
                    ? "yellow"
                    : text === 3
                      ? "purple"
                      : text === 4
                        ? "volcano"
                        : text === 5
                          ? "orange"
                          : "blue"
            }
          >
            <b>
              {text === 0 && "En attente"}
              {text === 1 && "Accepter"}
              {text === 2 && "En chemin"}
              {text === 3 && "Livrer"}
              {text === 4 && "Annuler"}
              {text === 5 && "Attente de rembourser"}
              {text === 6 && "Rembourser"}
            </b>
          </Tag>
        )
      },
      {
        title: "Date et Temps",
        dataIndex: "createdAt",
        render: (text) => <Tag>{text?.slice(0, 16)}</Tag>
      },
      {
        title: "Actions",
        fixed: "right",
        render: (text, record) => (
          <div>
            <Dropdown
              overlay={MenuButton(record)}
              placement="bottomCenter"
              arrow
            >
              <Button>Options</Button>
            </Dropdown>
          </div>
        )
      }
    ];

    const MenuButton = (record) => (
      <Menu>
        <Menu.Item>
          <Order_details row={record} />
        </Menu.Item>

        <Menu.Item>
          <Link onClick={() => this.handleStatus(record._id, 0)}>
            En attente
          </Link>
        </Menu.Item>

        <Menu.Item>
          <Link onClick={() => this.handleStatus(record._id, 1)}>Accepter</Link>
        </Menu.Item>

        <Menu.Item>
          <Link onClick={() => this.handleStatus(record._id, 2)}>
            En chemin
          </Link>
        </Menu.Item>

        <Menu.Item>
          <Link onClick={() => this.handleStatus(record._id, 3)}>Livrer</Link>
        </Menu.Item>

        <Menu.Item>
          <Link onClick={() => this.handleStatus(record._id, 4)}>Annuler</Link>
        </Menu.Item>

        <Menu.Item>
          <Link onClick={() => this.handleStatus(record._id, 5)}>
            Attente de remboursement
          </Link>
        </Menu.Item>

        <Menu.Item>
          <Link onClick={() => this.handleStatus(record._id, 6)}>
            Rembourser
          </Link>
        </Menu.Item>

        <Menu.Item>
          <Button type={"danger"} onClick={() => this.handleDelete(record._id)}>
            Supprimer
          </Button>
        </Menu.Item>
      </Menu>
    );

    const {
      load,
      data,
      start,
      end,
      chef,
      chef_selected,
      selected_date,
      isModalOpen,
      orderList,
      looking_done
    } = this.state;
    return (
      <>
        <PageHeader
          title="Commandes"
          tags={<Tag color="blue">Liste des commandes</Tag>}
          subTitle=""
          extra={[
            this.props.status === 1 && (
              <Button
                style={{
                  marginLeft: 10
                }}
                type={"danger"}
                onClick={() => {
                  this.showModal();
                }}
              >
                Rechercher des livreurs
              </Button>
            ),

            <CSVLink data={data}>Exporter CSV/Excel</CSVLink>
          ]}
        >
          <Row>
            <Statistic
              title="Total"
              value={
                data?.filter((item) => {
                  if (chef_selected === "all") {
                    return (
                      item?.status === this.props.status &&
                      item?.billing_details?.delivery_date === selected_date
                    );
                  }

                  if (chef_selected !== "all") {
                    return (
                      item?.status === this.props.status &&
                      item?.chef_id?._id === chef_selected &&
                      item?.billing_details?.delivery_date === selected_date
                    );
                  }
                  return (
                    item?.status === this.props.status &&
                    item?.chef_id?._id === chef_selected &&
                    item.createdAt >= start &&
                    item.createdAt <= end &&
                    item?.billing_details?.delivery_date === selected_date
                  );
                }).length
              }
            />
          </Row>

          <Row gutter={16}>
            {!load && (
              <>
                <Col span={4}>
                  <Form.Item
                    label="Selectionner un date"
                    rules={[
                      {
                        required: true,
                        role: "selectionner une date"
                      }
                    ]}
                  >
                    <input
                      name="selected_date"
                      type="date"
                      value={selected_date}
                      style={{
                        height: "33px",
                        border: "1px solid #e9e9e9",
                        backgroundColor: "#ffffff",
                        padding: 5
                      }}
                      onChange={(e) => {
                        this.setState({
                          selected_date: e.target.value
                        });
                      }}
                    />
                  </Form.Item>
                </Col>

                <Col span={4}>
                  <Form.Item
                    label="Selectionner un chef"
                    rules={[
                      {
                        required: true,
                        role: "selectionner un chef"
                      }
                    ]}
                  >
                    <Select
                      style={{ width: "100%" }}
                      placeholder="Selectionner un chef"
                      defaultValue={chef_selected}
                      onChange={(data) => {
                        return this.setState({ chef_selected: data });
                      }}
                    >
                      <Option key={"all"}>Tout les chefs</Option>
                      {chef
                        ?.filter((item) => {
                          return (
                            item?.firstname?.length > 0 &&
                            item?.lastname?.length > 0
                          );
                        })
                        ?.map((item) => (
                          <Option key={item?._id}>
                            <span>
                              {item?.firstname + " " + item?.lastname}
                            </span>
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                </Col>
              </>
            )}
          </Row>
          <Row
            style={{
              marginTop: 20
            }}
          >
            {load ? (
              <Space size="middle">
                <Spin size="large" />
              </Space>
            ) : (
              <Col span={24}>
                <Table
                  scroll={{
                    x: "auto"
                  }}
                  columns={columns}
                  dataSource={data?.filter((item) => {
                    if (chef_selected === "all") {
                      return (
                        item?.status === this.props.status &&
                        item?.billing_details?.delivery_date === selected_date
                      );
                    }

                    if (chef_selected !== "all") {
                      return (
                        item?.status === this.props.status &&
                        item?.chef_id?._id === chef_selected &&
                        item?.billing_details?.delivery_date === selected_date
                      );
                    }
                    return (
                      item?.status === this.props.status &&
                      item?.chef_id?._id === chef_selected &&
                      item.createdAt >= start &&
                      item.createdAt <= end &&
                      item?.billing_details?.delivery_date === selected_date
                    );
                  })}
                />
              </Col>
            )}
            <Modal
              title="Rechercher des livreurs"
              visible={isModalOpen}
              onOk={() => this.handleOk()}
              onCancel={() => this.handleCancel()}
              footer={null}
            >
              <p>Liste des commandes du {reverseDateFormat(selected_date)}</p>
              <br />
              {data?.filter((item) => {
                if (chef_selected === "all") {
                  return (
                    item?.status === this.props.status &&
                    item?.billing_details?.delivery_date === selected_date
                  );
                }

                if (chef_selected !== "all") {
                  return (
                    item?.status === this.props.status &&
                    item?.chef_id?._id === chef_selected &&
                    item?.billing_details?.delivery_date === selected_date
                  );
                }
                return (
                  item?.status === this.props.status &&
                  item?.chef_id?._id === chef_selected &&
                  item.createdAt >= start &&
                  item.createdAt <= end &&
                  item?.billing_details?.delivery_date === selected_date
                );
              }).length > 0 && (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    height: 40,
                    gap: 5
                  }}
                  onClick={() => {
                    if (looking_done) {
                      return;
                    }

                    if (
                      orderList.length ===
                      data?.filter((item) => {
                        if (chef_selected === "all") {
                          return (
                            item?.status === this.props.status &&
                            item?.billing_details?.delivery_date ===
                              selected_date
                          );
                        }

                        if (chef_selected !== "all") {
                          return (
                            item?.status === this.props.status &&
                            item?.chef_id?._id === chef_selected &&
                            item?.billing_details?.delivery_date ===
                              selected_date
                          );
                        }
                        return (
                          item?.status === this.props.status &&
                          item?.chef_id?._id === chef_selected &&
                          item.createdAt >= start &&
                          item.createdAt <= end &&
                          item?.billing_details?.delivery_date === selected_date
                        );
                      }).length
                    ) {
                      return this.setState({ orderList: [] });
                    }

                    this.setState((prevState) => {
                      const orderList = [...prevState.orderList];

                      data
                        ?.filter((item) => {
                          if (chef_selected === "all") {
                            return (
                              item?.status === this.props.status &&
                              item?.billing_details?.delivery_date ===
                                selected_date
                            );
                          }

                          if (chef_selected !== "all") {
                            return (
                              item?.status === this.props.status &&
                              item?.chef_id?._id === chef_selected &&
                              item?.billing_details?.delivery_date ===
                                selected_date
                            );
                          }
                          return (
                            item?.status === this.props.status &&
                            item?.chef_id?._id === chef_selected &&
                            item.createdAt >= start &&
                            item.createdAt <= end &&
                            item?.billing_details?.delivery_date ===
                              selected_date
                          );
                        })
                        .forEach((item) => {
                          if (!orderList.includes(item._id)) {
                            orderList.push(item._id);
                          }
                        });

                      return { orderList };
                    });
                  }}
                >
                  <div
                    style={{
                      width: 20,
                      height: 20,
                      borderRadius: 10,
                      border: "1px solid #cecece",
                      backgroundColor:
                        orderList.length ===
                        data?.filter((item) => {
                          if (chef_selected === "all") {
                            return (
                              item?.status === this.props.status &&
                              item?.billing_details?.delivery_date ===
                                selected_date
                            );
                          }

                          if (chef_selected !== "all") {
                            return (
                              item?.status === this.props.status &&
                              item?.chef_id?._id === chef_selected &&
                              item?.billing_details?.delivery_date ===
                                selected_date
                            );
                          }
                          return (
                            item?.status === this.props.status &&
                            item?.chef_id?._id === chef_selected &&
                            item.createdAt >= start &&
                            item.createdAt <= end &&
                            item?.billing_details?.delivery_date ===
                              selected_date
                          );
                        }).length
                          ? "red"
                          : "#fff"
                    }}
                  ></div>
                  <span>Toutes les commandes</span>
                </div>
              )}
              <div>
                {data
                  ?.filter((item) => {
                    if (chef_selected === "all") {
                      return (
                        item?.status === this.props.status &&
                        item?.billing_details?.delivery_date === selected_date
                      );
                    }

                    if (chef_selected !== "all") {
                      return (
                        item?.status === this.props.status &&
                        item?.chef_id?._id === chef_selected &&
                        item?.billing_details?.delivery_date === selected_date
                      );
                    }
                    return (
                      item?.status === this.props.status &&
                      item?.chef_id?._id === chef_selected &&
                      item.createdAt >= start &&
                      item.createdAt <= end &&
                      item?.billing_details?.delivery_date === selected_date
                    );
                  })
                  ?.map((item) => (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        height: 40,
                        gap: 5
                      }}
                      onClick={() => {
                        if (looking_done) {
                          return;
                        }
                        this.setState((prevState) => {
                          const orderList = [...prevState.orderList];
                          const itemIndex = orderList.indexOf(item?._id);

                          if (itemIndex > -1) {
                            // Item exists, remove it
                            orderList.splice(itemIndex, 1);
                          } else {
                            // Item doesn't exist, add it
                            orderList.push(item?._id);
                          }

                          return { orderList };
                        });
                      }}
                    >
                      <div
                        style={{
                          width: 20,
                          height: 20,
                          borderRadius: 10,
                          border: "1px solid #cecece",
                          backgroundColor: orderList.includes(item?._id)
                            ? "red"
                            : "#fff"
                        }}
                      ></div>
                      <span>
                        <span>
                          <b>
                            {"$" + item?.billing_details?.amount?.toFixed(2)}
                          </b>
                        </span>
                      </span>
                      <span>
                        Chef{" "}
                        {item?.chef_id?.firstname +
                          " " +
                          item?.chef_id?.lastname}
                      </span>
                      <span>{item?.food?.length} Article(s)</span>
                    </div>
                  ))}
              </div>
              {!looking_done && !load && (
                <Button
                  type={"danger"}
                  onClick={() => {
                    this.startBroadcast();
                  }}
                >
                  Lancer la recherche
                </Button>
              )}
              {looking_done && !load && (
                <span
                  type={"default"}
                  disabled={true}
                  style={{
                    marginTop: 20
                  }}
                >
                  Les recherches sont en cours et ont une durée moyenne de 3
                  minutes, vous pouvez actualiser la page à la fin des
                  recherches en{" "}
                  <a
                    onClick={() => {
                      return window.location.reload();
                    }}
                  >
                    cliquant ici
                  </a>
                </span>
              )}
            </Modal>
          </Row>
        </PageHeader>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    admin: state.admin
  };
};

const mapDispatchStoreToProps = () => {
  return {};
};

export default connect(mapStateToProps, mapDispatchStoreToProps)(Order);
